/* eslint-disable react/forbid-prop-types */
import React, {useState, useMemo, memo} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {sortBy} from 'lodash';
import CreateEditControlModalWrapper from '../../../../../../../../Common/EntityCrud/CreateEditControlModalWrapper';
import {useCanvasFormMetadata} from '../../../../../../../../../util/customHooks';

const ControlsList = ({className, title, controls, placeholderText, documentId, bodyId}) => {
	const [showModal, setShowModal] = useState(false),
		[currentControlId, setCurrentControlId] = useState(null);

	const {isShared, isTargetEngagement} = useCanvasFormMetadata();

	const sortedControls = useMemo(() => {
		return controls?.length > 0 && sortBy(controls, (control) => control.controlName);
	}, [controls]);

	return (
		<section className={className}>
			<section className="controls-title-and-count">
				<span className="control-title">{`${title}`}</span>
				{controls.length > 0 && <span className="control-count">{`- ${controls.length}`}</span>}
			</section>
			{controls && controls.length > 0 ? (
				sortedControls.map((control) => {
					return (
						<>
							<span
								id={control.id}
								className="control-name"
								onClick={() => {
									setShowModal(true);
									setCurrentControlId(control.id);
								}}
							>
								{control.controlName}
							</span>
							{showModal && currentControlId === control.id && (
								<CreateEditControlModalWrapper
									documentId={documentId}
									bodyId={bodyId}
									isEdit
									showModal={showModal}
									setShowModal={setShowModal}
									onClose={setShowModal}
									controlId={Number(control.id)}
									viewOnly={isShared && isTargetEngagement ? true : false}
								/>
							)}
						</>
					);
				})
			) : (
				<section className="emptyContainer">{placeholderText}</section>
			)}
		</section>
	);
};

ControlsList.displayName = 'ControlsList';

ControlsList.propTypes = {
	className: PropTypes.string,
	title: PropTypes.string,
	controls: PropTypes.array,
	placeholderText: PropTypes.string,
	onNameClick: PropTypes.func
};

const StyledViewControl = styled(ControlsList)`
	margin-bottom: var(--px-25);
	.controls-title-and-count {
		padding: var(--px-5) 0;
		border-bottom: var(--px-1) solid var(--neutrals-200);
	}
	.control-title {
		font-size: var(--px-12);
		font-weight: bold;
		color: var(--neutrals-900);
		line-height: normal;
	}
	.control-count {
		font-size: var(--px-12);
		font-weight: 300;
		color: var(--neutrals-900);
		padding-left: var(--px-3);
	}
	.emptyContainer {
		font-size: var(--px-12);
		font-weight: 300;
		color: var(--neutrals-700);
		padding: var(--px-10) 0;
	}
	.control-name {
		font-size: var(--px-12);
		font-weight: bold;
		color: var(--blue-600);
		display: block;
		padding: var(--px-10) 0;
		border-bottom: var(--px-1) solid var(--neutrals-200);
		line-height: normal;
		cursor: pointer;
		&:last-child {
			border: 0;
		}
	}
`;

export default memo(StyledViewControl);
